import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfessional = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "professional",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12494",
			"data-name": "Path 12494",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12495",
			"data-name": "Path 12495",
			d: "M20,10.5V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V15",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12496",
			"data-name": "Path 12496",
			d: "M15,18H3a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1H15",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12497",
			"data-name": "Path 12497",
			d: "M21,21H16a1,1,0,0,1-1-1V11.5a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1V20A1,1,0,0,1,21,21Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12498",
			"data-name": "Path 12498",
			d: "M15,18h7",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgProfessional;
